<script setup lang="ts">
// "Refresh to update": polls /api/version and shows a bar when the running
// build is no longer the deployed one. All app files are no-cache, so a
// reload is a full, consistent update (HERverse's half-updated-app bug).
import { onBeforeUnmount, onMounted, ref } from 'vue'

const built = __GIT_SHA__
const stale = ref(false)
let timer: ReturnType<typeof setInterval> | undefined
const reload = () => window.location.reload()

async function check() {
  try {
    const res = await fetch('/api/version', { cache: 'no-store' })
    if (!res.ok) return
    const { version } = (await res.json()) as { version: string }
    if (version && built !== 'dev' && version !== built) stale.value = true
  } catch {
    /* offline: nothing to say */
  }
}

onMounted(() => {
  void check()
  timer = setInterval(check, 60_000)
})
onBeforeUnmount(() => clearInterval(timer))
</script>

<template>
  <div
    v-if="stale"
    role="status"
    class="update-banner"
    style="position:fixed;top:0;left:0;right:0;z-index:1000;display:flex;justify-content:center;gap:12px;align-items:center;padding:10px 16px;background:#1f6f8b;color:#fff;font:600 14px system-ui,sans-serif"
  >
    <span>A new version is available.</span>
    <button
      type="button"
      style="appearance:none;border:0;border-radius:999px;padding:8px 14px;background:#fff;color:#1f6f8b;font:inherit;cursor:pointer;min-height:36px"
      @click="reload"
    >
      Refresh
    </button>
  </div>
</template>
